/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeSystemListItems.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   System List Items Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const SYSTEMLISTITEM_LIST_CONTAINER_LOADED = 'SYSTEMLISTITEM_LIST_CONTAINER_LOADED';
export const SYSTEMLISTITEM_LIST_CONTAINER_UNLOADED = 'SYSTEMLISTITEM_LIST_CONTAINER_UNLOADED';
export const SYSTEMLISTITEM_LIST_TABLE_LOADED = 'SYSTEMLISTITEM_LIST_TABLE_LOADED';
export const SYSTEMLISTITEM_LIST_TABLE_UNLOADED = 'SYSTEMLISTITEM_LIST_TABLE_UNLOADED';
export const SYSTEMLISTITEM_SELECT_ROW = 'SYSTEMLISTITEM_SELECT_ROW';
export const SYSTEMLISTITEM_ADD = 'SYSTEMLISTITEM_ADD';
export const SYSTEMLISTITEM_EDIT = 'SYSTEMLISTITEM_EDIT';
export const SYSTEMLISTITEM_DELETE = 'SYSTEMLISTITEM_DELETE';
export const SYSTEMLISTITEM_DELETE_DISABLE = 'SYSTEMLISTITEM_DELETE_DISABLE';
export const SYSTEMLISTITEM_OPEN_WARNING = 'SYSTEMLISTITEM_OPEN_WARNING';
export const SYSTEMLISTITEM_CLOSE_WARNING = 'SYSTEMLISTITEM_CLOSE_WARNING';
export const SYSTEMLIST_VIEW_LISTITEMS = 'SYSTEMLIST_VIEW_LISTITEMS';

export const SYSTEMLISTITEM_EDIT_CONTAINER_LOADED = 'SYSTEMLISTITEM_EDIT_CONTAINER_LOADED';
export const SYSTEMLISTITEM_EDIT_CONTAINER_UNLOADED = 'SYSTEMLISTITEM_EDIT_CONTAINER_UNLOADED';
export const SYSTEMLISTITEM_EDIT_FORM_LOADED = 'SYSTEMLISTITEM_EDIT_FORM_LOADED';
export const SYSTEMLISTITEM_EDIT_FORM_UNLOADED = 'SYSTEMLISTITEM_EDIT_FORM_UNLOADED';
export const SYSTEMLISTITEM_EDIT_DATA_LOAD = 'SYSTEMLISTITEM_EDIT_DATA_LOAD';
export const SYSTEMLISTITEM_EDIT_CONTAINER_SUBMIT = 'SYSTEMLISTITEM_EDIT_CONTAINER_SUBMIT';
export const SYSTEMLISTITEM_EDIT_CONTAINER_CANCEL = 'SYSTEMLISTITEM_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeSystemListItems.js